var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"files-single-section flex column gap20 width-all",attrs:{"id":_vm.sectionId}},[(_vm.title && _vm.showTitle)?_c('h2',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('FileList',{attrs:{"rootItem":_vm.rootItem,"files":_vm.files,"cmpType":_vm.cmpType,"organizationId":_vm.organizationId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }